import {UserRole} from "../enums/UserRolesEnums";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import {UserEngagementType} from "@/shared/enums/UserEngagementTypesEnums";

export function getMenuLinks() {

    const piniaCompanySettingsState = piniaCompanySettingsStore();
    const companySettings = piniaCompanySettingsState.companySettings;

    const menuItems = [];

    // Dashboard -------
    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardAdminInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.ADMIN],
        type: ['intern']
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboard-coach',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.COACH, UserRole.THERAPIST]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboard-assistant_vq',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.ASSISTANT_VQ],
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardPersonalInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.PERSONAL, UserRole.HEAD_OF_HR]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardAccountantInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.ACCOUNTANT]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardHeadAMDLInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.HEAD_OF_AMDL]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboard-head_of_marketing',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.HEAD_OF_MARKETING]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardHeadOccupationalTherapyInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.HEAD_OF_OCCUPATIONAL_THERAPY]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardHeadPsychosocialServicesInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboard-site_manager',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.SITE_MANAGER]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboard-site_support',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.SITE_SUPPORT]
    });

    menuItems.push({
        title: 'Dashboard',
        name: 'dashboardPracticeManagerInfo',
        icon: 'os-icon os-icon-layout',
        roles: [UserRole.PRACTICE_MANAGER]
    });


    // Calendar
    if (companySettings?.calendarEnabled) {
        menuItems.push({
            title: 'Kalender',
            name: 'calendar',
            icon: 'os-icon os-icon-calendar',
            roles: [
                UserRole.ADMIN,
                UserRole.COACH,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT,
            ],
        });
    }

    // Time management
    if (companySettings?.timeManagementEnabled) {
        menuItems.push({
            title: 'Time management',
            icon: 'os-icon os-icon-calendar-time',
            engagementTypes: [
                UserEngagementType.INTERN,
                UserEngagementType.OTHERS
            ],
            roles: [
                UserRole.ADMIN,
                UserRole.COACH,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT,
            ],
            submenu: [
                {
                    title: 'Stundenerfassung',
                    name: 'hourlyOverview',
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                {
                    title: 'HR Übersicht',
                    name: 'monthlyOverview',
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR
                    ]
                },
                {
                    title: 'Vorgesetzte Übersicht',
                    name: 'monthlyOverviewCoordinator',
                    roles: [
                        UserRole.ADMIN,
                        UserRole.SITE_MANAGER,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                    ],
                    hasUserId: true
                },
                {
                    title: 'Fahrtkosten',
                    name: 'travelExpensesPendingAndActiveList',
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                }
            ]
        });
    }


    // Course
    const courseSubmenu = [];

    if (companySettings?.privateCoachingEnabled) {
        courseSubmenu.push(
            {
                title: 'Einzelcoachingmaßnahmen',
                name: 'coursePrivateCoachingList',
                roles: [
                    UserRole.ADMIN,
                    UserRole.PERSONAL,
                    UserRole.HEAD_OF_HR,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.ACCOUNTANT,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.ASSISTANT_VQ,
                    UserRole.PRACTICE_MANAGER,
                ]
            },
            {
                title: 'Einzelcoaching module',
                name: 'coursePrivateCoachingModuleList',
                roles: [
                    UserRole.ADMIN,
                    UserRole.PERSONAL,
                    UserRole.HEAD_OF_HR,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.ACCOUNTANT,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.ASSISTANT_VQ,
                    UserRole.PRACTICE_MANAGER,
                ]
            }
        );
    }

    if (companySettings?.groupCoachingEnabled) {
        courseSubmenu.push({
            title: 'Gruppenmaßnahmen',
            name: 'courseGroupCoachingList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ASSISTANT_VQ,
                UserRole.PRACTICE_MANAGER,
            ]
        });
    }

    if (companySettings?.privateLearningCoachingEnabled) {
        courseSubmenu.push(
            {
                title: 'Private Weiterbildungen',
                name: 'coursePrivateLearningCoachingList',
                roles: [
                    UserRole.ADMIN,
                    UserRole.PERSONAL,
                    UserRole.HEAD_OF_HR,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.ACCOUNTANT,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.ASSISTANT_VQ,
                ]
            },
            {
                title: 'Private Weiterbildungen module',
                name: 'coursePrivateLearningCoachingModuleList',
                roles: [
                    UserRole.ADMIN,
                    UserRole.PERSONAL,
                    UserRole.HEAD_OF_HR,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.ACCOUNTANT,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.ASSISTANT_VQ,
                ]
            }
        );
    }

    if (companySettings?.assistedLivingCoachingEnabled) {
        courseSubmenu.push({
            title: 'Preisliste für betreute Wohnmaßnahmen',
            name: 'courseAssistedLivingCoachingPriceList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ASSISTANT_VQ,
                UserRole.PRACTICE_MANAGER,
            ]
        });
    }

    if (companySettings?.socioTherapyCoachingEnabled) {
        courseSubmenu.push({
            title: 'Preisliste für Soziotherapie',
            name: 'courseSocioTherapyCoachingPriceList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ASSISTANT_VQ,
                UserRole.PRACTICE_MANAGER,
            ]
        });
    }

    if (courseSubmenu.length) {
        menuItems.push({
            title: 'Leistungstyp',
            icon: 'os-icon os-icon-documents-03',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.ACCOUNTANT,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ASSISTANT_VQ,
                UserRole.PRACTICE_MANAGER,
            ],
            submenu: courseSubmenu
        });
    }

    // Locations - offices
    const locationSubmenu = [];

    if (companySettings?.locationEnabled) {
        locationSubmenu.push({
            title: 'Liste der Standorte',
            name: 'officeList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ
            ]
        });

        locationSubmenu.push({
            title: 'Audits',
            name: 'auditOfficeList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.SITE_MANAGER,
                UserRole.ASSISTANT_VQ
            ]
        });

        locationSubmenu.push({
            title: 'Feiertage in Regionen',
            name: 'regionList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.ASSISTANT_VQ
            ]
        });

        locationSubmenu.push({
            title: 'Besprechungsräume',
            name: 'meetingRoomList',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.ASSISTANT_VQ
            ]
        });
    }

    if (locationSubmenu.length) {
        menuItems.push({
            title: 'Standorte',
            icon: 'os-icon os-icon-home',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.SITE_MANAGER,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ
            ],
            submenu: locationSubmenu
        });
    }


    // Client
    const clientSubmenu = [];

    if (companySettings?.clientEnabled) {
        clientSubmenu.push({
            title: 'Kostenträgerliste',
            name: 'clientList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ]
        });

        clientSubmenu.push({
            title: 'Liste der zugewiesenen Jobcenter',
            name: 'subClientList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ]
        });
    }

    if (clientSubmenu.length) {
        menuItems.push({
            title: 'Kostenträger',
            icon: 'os-icon os-icon-finance-29',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
            submenu: clientSubmenu
        });
    }


    // Address book
    const contactSubmenu = [];

    if (companySettings?.addressBookEnabled) {
        contactSubmenu.push({
            title: 'Firmenkontakte',
            name: 'addressBookCompanyList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
        });

        contactSubmenu.push({
            title: 'Kostenträgerkontakte',
            name: 'addressBookClientList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
        });

        contactSubmenu.push({
            title: 'Ärzte/Therapeuten',
            name: 'addressBookDoctorList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
        });

        contactSubmenu.push({
            title: 'Privatkunden',
            name: 'addressBookPrivateCustomerList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
        });

        contactSubmenu.push({
            title: 'Partnerpraxen',
            name: 'addressBookPartnerPracticesList',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
        });
    }

    if (contactSubmenu.length) {
        menuItems.push({
            title: 'Kontakte',
            icon: 'os-icon os-icon-book-open',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ],
            submenu: contactSubmenu
        });
    }

    // Unemployed
    if (companySettings?.unemployedEnabled) {
        menuItems.push({
            title: 'Kunden',
            name: 'unemployedNewAndActiveList',
            icon: 'os-icon os-icon-search',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
            ]
        });
    }

    // Users
    if (companySettings?.userEnabled) {
        menuItems.push({
            title: 'Mitarbeiter',
            name: 'userList',
            icon: 'os-icon os-icon-user-check',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT
            ]
        });
    }


    // Portal
    if (
        companySettings?.privateCoachingEnabled ||
        companySettings?.groupCoachingEnabled ||
        companySettings?.socioTherapyCoachingEnabled ||
        companySettings?.privateLearningCoachingEnabled ||
        companySettings?.assistedLivingCoachingEnabled ||
        companySettings?.caseManagementCoachingEnabled
    ) {
        menuItems.push({
            title: 'Übersicht',
            name: 'coachingOverview',
            icon: 'os-icon os-icon-list',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT,
            ]
        });
    }

    if (companySettings?.analyticsEnabled) {
        menuItems.push({
            title: 'Auswertung',
            name: 'analyticsHome',
            icon: 'os-icon os-icon-bar-chart',
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.ASSISTANT_VQ,
            ]
        });
    }

    // Billing
    const billingSubmenu = [];

    if (companySettings?.billingEnabled) {
        billingSubmenu.push({
            title: 'Rechnungslegung',
            name: 'billingLatestBills',
            roles: [
                UserRole.ADMIN,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT
            ],
        });
    }

    if (companySettings?.coachBillingEnabled) {
        billingSubmenu.push({
            title: 'Externe Coachabrechnung',
            name: 'coachBillingExistedBills',
            roles: [
                UserRole.ADMIN,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT
            ],
        });
    }

    if (billingSubmenu.length) {
        menuItems.push({
            title: 'Rechnungslegung',
            icon: 'fa fa-euro-sign',
            roles: [
                UserRole.ADMIN,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT
            ],
            submenu: billingSubmenu
        });
    }

    // Deleted records
    if (companySettings?.deletedRecordsEnabled) {
        menuItems.push({
            title: 'Gelöschte Datensätze',
            name: 'deletedRecordsHome',
            icon: 'os-icon os-icon-delete',
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR
            ]
        });
    }

    // AI document scan
    if (companySettings?.aiDocumentScanEnabled) {
        menuItems.push({
            title: 'AI Document scan',
            name: 'aiDocumentScan',
            icon: 'os-icon os-icon-coins-4',
            roles: [
                UserRole.ADMIN,
                UserRole.PRACTICE_MANAGER,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES
            ]
        });
    }


    //--------- FOR ADMIN ONLY ---------
    // Online users
    menuItems.push({
        title: 'Online-Benutzer',
        name: 'onlineUsers',
        icon: 'fa-solid fa-user-clock',
        roles: [UserRole.ADMIN]
    });

    // Email send
    menuItems.push({
        title: 'E-Mails senden',
        name: 'sendEmailList',
        icon: 'os-icon os-icon-email-2-at2',
        roles: [UserRole.ADMIN]
    });

    // System monitoring (Cron execution + System exception log)
    menuItems.push({
        title: 'System monitoring',
        icon: 'os-icon os-icon-alert-triangle',
        roles: [UserRole.ADMIN],
        submenu: [
            {
                title: 'Cron execution',
                name: 'cronExecutionList',
                roles: [UserRole.ADMIN]
            },
            {
                title: 'System exception log',
                name: 'systemExceptionLogList',
                roles: [UserRole.ADMIN]
            },
            {
                title: 'Messenger execution log',
                name: 'messengerExecutionLogList',
                roles: [UserRole.ADMIN]
            }
        ]
    });

    // Company settings
    menuItems.push({
        title: 'Firmeneinstellungen',
        name: 'companySettings',
        icon: 'fa-solid fa-gear',
        roles: [UserRole.ADMIN]
    })

    return menuItems;

}